import { render, staticRenderFns } from "./PermissionForm.vue?vue&type=template&id=78d58de2&"
import script from "./PermissionForm.vue?vue&type=script&lang=js&"
export * from "./PermissionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports